export default __webpack_public_path__ + "static/media/pencil-dark.a058cf19.svg";